
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    return {
      throwError() {
        throw new Error("Sentry Error");
      },
    };
  },
});
